<template>
    <div class="menu-container">
        <RouterLink v-for="item in items" :exact="item.exact" :key="item.link" :to="{ name: item.name }">
            <div class="icon">
                <Icon :type="item.icon" />
            </div>
            <span>{{ item.title }}</span>
        </RouterLink>
    </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
    components: {
        Icon,
    },
    data() {
        return {
            items: [
                {
                    name: "Home",
                    title: "首页",
                    icon: "home",
                    exact: true,
                },
                {
                    name: "Blog",
                    title: "文章",
                    icon: "blog",
                    exact: false,
                },
                {
                    name: "About",
                    title: "关于我",
                    icon: "about",
                    exact: true,
                },
                {
                    name: "Project",
                    title: "项目",
                    icon: "code",
                    exact: true,
                },
                {
                    name: "Message",
                    title: "留言板",
                    icon: "chat",
                    exact: true,
                },
            ]
        }
    },

};
</script>

<style scoped lang="less">
@import "../style/var.less";

.menu-container {
    color: @gray;
    margin: 24px 0;

    a {
        display: block;
        padding: 0 50px;
        display: flex;
        align-items: center;
        height: 45px;

        .icon {
            font-size: 24px;
        }

        &:hover {
            color: #fff;
        }

        // &.router-link-exact-active {
        //     background: #2d2d2d;
        // }
        &.router-link-active {
            background: #2d2d2d;
        }
    }
}
</style>